import React from 'react';
import { TableRow, TableCell } from 'semantic-ui-react';

import {
    WorksheetPageIndex,
    WorksheetEntitySummaryIndex
} from 'services/worksheet/types';
import SprayEventTypeCropGate from 'components/SprayEventTypeCropGate';
import OrchardTableCell from './components/OrchardTableCell';
import BlocksTableCell from './components/BlocksTableCell';
import HectaresTableCell from './components/HectaresTableCell';
import TanksEstimatedTableCell from './components/TanksEstimatedTableCell';
import ApplicationTypeTableCell from './components/ApplicationTypeTableCell';
import StartingRowTableCell from './components/StartingRowTableCell';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

type Props = OwnProps;

export default class PrintSprayWorksheetCompletionDetailsTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { entitySummaryIndex, pageIndex } = this.props;

        return (
            <TableRow>
                <OrchardTableCell
                    entitySummaryIndex={entitySummaryIndex}
                    pageIndex={pageIndex}
                />
                <BlocksTableCell
                    entitySummaryIndex={entitySummaryIndex}
                    pageIndex={pageIndex}
                />
                <HectaresTableCell
                    entitySummaryIndex={entitySummaryIndex}
                    pageIndex={pageIndex}
                />
                <TanksEstimatedTableCell
                    entitySummaryIndex={entitySummaryIndex}
                    pageIndex={pageIndex}
                />
                <SprayEventTypeCropGate>
                    <React.Fragment>
                        <ApplicationTypeTableCell
                            entitySummaryIndex={entitySummaryIndex}
                            pageIndex={pageIndex}
                        />
                        <StartingRowTableCell
                            entitySummaryIndex={entitySummaryIndex}
                            pageIndex={pageIndex}
                        />
                    </React.Fragment>
                </SprayEventTypeCropGate>
                {/* Empty cells will be filled in manually once it's printed */}
                <TableCell>{}</TableCell>
                <TableCell>{}</TableCell>
            </TableRow>
        );
    }
}
